import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Button from "../button"; // your button component
import MathExpressionNew from '../../components/common/mathjax'; // Adjust the import path as needed
import { Loader, arrowDown, vIcon, orangeVIcon } from "../../assets/images/index";
import { useTranslation } from "react-i18next";
import { TrackingService } from  "../../services/tracking/tracking.service";
import { useExerciseStore } from "../../utils/exerciseStore";
import { useQuestionsStore } from "../../utils/questionStore";
import { useStepsStore } from "../../utils/stepStore";
import "./question-steps-list.scss"; // Adjust the import path as needed

interface Step {
  id: number;
  title: string;
  content: string;
}

interface QuestionStepsListProps {
  steps: Step[];
  expanded: string | false;
  selectedStep: number | null;
  isViewOnly?: boolean; // true for chat footer (minimal UI), false or undefined for full UI
  onAccordionChange: (panelId: string, index: number) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  handleProceedToChat?: (index: number) => void;  
  currentStepIndex?: number;
  errorMessage?: string | null;
}

const QuestionStepsList: React.FC<QuestionStepsListProps> = ({
  steps,
  expanded,
  selectedStep,
  isViewOnly = false,
  onAccordionChange,
  handleProceedToChat,  
  currentStepIndex,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const trackingServiceInstance = new TrackingService();
  const exerciseFilename = useExerciseStore((s) => s.selectedExerciseName);
  const selectedQuestion = useQuestionsStore((s) => s.selectedQuestionLetter);
  const stepHistory = useStepsStore((state) => state.step_history);

  const handleSelectedStepTracking = (index: number) => {
    trackingServiceInstance.trackEvent("click_on_step", {
      source: "questionstepspage",
      selected_exercise: exerciseFilename || "",
      selected_question: selectedQuestion,
      selected_step_name: `שלב ${index + 1}`,
      });
  }

  const handleSelectedStep = (panelId: string,index: number) => {
    handleSelectedStepTracking(index);
    console.log("Selected step index:", index);
    if (handleProceedToChat) {
      handleProceedToChat(index);
    }
  };


  return (
    <div className="question-steps-inner">
      {!isViewOnly && (
        <>
          <h2>{t("questionStepsTitle")}</h2>                      
          {steps.length === 0 && !errorMessage && (
            <div className="loaderBlock">
              {t("thinking")}...
              <img src={Loader} alt="Loading..." />
            </div>
          )}

          {errorMessage && (
            <div className="errorBlock">
              <p style={{ color: "red", fontWeight: "bold" }}>{errorMessage}</p>
            </div>
          )}
          
        </>
      )}

      {steps.map((step, index) => {
        const panelId = `panel${index}`;
        const isCompleted = stepHistory?.completed?.includes(step.id);
        const isInProcess = stepHistory?.in_process?.includes(step.id);
        return (
          <Accordion
            className="accordionBox"
            key={index}
            expanded={true} // Always open
            onChange={onAccordionChange(panelId, index)}
          >
            <AccordionSummary
              expandIcon={<img src={arrowDown} alt="arrow" className="acc_arrow"/>}
              aria-controls={`${panelId}-content`}
              id={`${panelId}-header`}
              onClick={() => handleSelectedStep(panelId,index)}
              style={{ cursor: handleProceedToChat ? "pointer" : undefined }}              
            >
              <span className="tag">{index + 1}</span>
              <MathExpressionNew content={step.title} />
              {isCompleted && <div className="step-completed-icon">{t("completed")}</div>}
              {isInProcess && <div className="step-in-progress-icon">{t("inProgress")}</div>}
            </AccordionSummary>
            <AccordionDetails>
              <MathExpressionNew content={step.content} />
            </AccordionDetails>
          </Accordion>
        );
      })}

    </div>
  );
};

export default QuestionStepsList;
